export default __webpack_public_path__ + "static/media/2526 spice rack side.4e081255.png";